module.exports = __webpack_public_path__ + "static/img/5.a3a3a6d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/5/sp/5.png
// module id = 6eKT
// module chunks = 0